const music = [
    {
        title: 'Dreamerr',
        artist: 'Zachary Lipscomb',
        img_src: "./images/dreamerr.jpg",
        src: "./music/dreamerr.mp3",
    },
    {
        title: 'Medicine',
        artist: 'Zachary Lipscomb',
        img_src: "./images/dreamerr.jpg",
        src: "./music/medicine.mp3",
    },
    {
        title: 'Rebel Life',
        artist: 'Zachary Lipscomb',
        img_src: './images/dreamerr.jpg',
        src: './music/rebel-life.mp3',
    },
    {
        title: 'Save the Day',
        artist: 'Zachary Lipscomb',
        img_src: './images/dreamerr.jpg',
        src: './music/save-the-day.mp3',
    },
    {
        title: 'Butterflies',
        artist: 'Zachary Lipscomb',
        img_src: './images/dreamerr.jpg',
        src: './music/butterflies.mp3',
    },
    {
        title: 'Wake Up',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/wakeup.mp3",
    },
    {
        title: 'Get Out',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/getout.mp3",
    },
    {
        title: 'Blow',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/blow.mp3",
    },
    {
        title: 'Spyware',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/spyware.mp3",
    },
    {
        title: 'About Us',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/aboutus.mp3",
    },
    {
        title: 'Unchained',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/unchained.mp3",
    },
    {
        title: 'Genesis',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/genesis.mp3",
    },
    {
        title: 'Mirrors',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/mirrors.mp3",
    },
    {
        title: 'Momento',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/momento.mp3",
    },
    {
        title: 'Providence',
        artist: 'Zachary Lipscomb',
        img_src: "./images/flux.jpg",
        src: "./music/providence.mp3",
    },
    {
        title: 'My Heart',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/myheart.mp3",
    },
    {
        title: 'Live Again',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/liveagain.mp3",
    },
    {
        title: 'Real Love',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/reallove.mp3",
    },
    {
        title: 'Sheep',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/sheep.mp3",
    },
    {
        title: 'Battle Cry',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/battlecry.mp3",
    },
    {
        title: 'About Us',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/aboutus.mp3",
    },
    {
        title: 'Freedom',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/freedom.mp3",
    },
    {
        title: 'Evil Eye',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/evileye.mp3",
    },
    {
        title: 'On Top',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/ontop.mp3",
    },
    {
        title: 'Corrupted',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/corrupted.mp3",
    },
    {
        title: 'Black Liberation',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/blackliberation.wav",
    },
    {
        title: 'They Dont Know',
        artist: 'Zachary Lipscomb',
        img_src: "./images/nexus.jpg",
        src: "./music/theydontknow.mp3",
    },
    {
        title: 'The Way',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/theway.mp3",
    },
    {
        title: 'Stay Strong',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/staystrong.mp3",
    },
    {
        title: 'Love and Faith',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/loveandfaith.mp3",
    },
    {
        title: 'Strange Fruit',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/strangefruit.mp3",
    },
    {
        title: 'The Prayer',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/theprayer.mp3",
    },
    {
        title: 'Imagine',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/imagine.mp3",
    },
    {
        title: 'Eternal',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/eternal.mp3",
    },
    {
        title: 'Good Music',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/goodmusic.mp3",
    },
    {
        title: 'Exodus',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/exodus.mp3",
    },
    {
        title: 'Womans World',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/womansworld.mp3",
    },
    {
        title: 'Always Be',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/alwaysbe.mp3",
    },
    {
        title: 'Sin City',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/sincity.mp3",
    },
    {
        title: 'The Revelation',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/therevelation.mp3",
    },
    {
        title: 'They Zone',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/thezone.mp3",
    },
    {
        title: 'Me and U',
        artist: 'Zachary Lipscomb',
        img_src: "./images/totalawareness.jpg",
        src: "./music/meandu.mp3",
    },

]

export default music